module.exports = __webpack_public_path__ + "static/media/banner-web-amazon-5-percent@3x.b1f989f2.png";